import React from "react";
import RefundRequestsItems from "../RefundRequests/RefundRequestsItems/RefundRequestsItems";

const RefundRequestsItemsBuyer = (props) => (
  <RefundRequestsItems
    {...props}
    backPath="/admin/refund-requests-buyer"
    companyType="wholesale_customer"
  />
);

export default RefundRequestsItemsBuyer;
